import React, { useEffect, useState } from 'react';
import CardWIconTitleAndButton from '../../../components/card/CardWIconTitleAndButton/CardWIconTitleAndButton';
import FooterWImageAndActionButtons from '../../../components/footerwimageandactionbuttons/FooterWImageAndActionButtons';
import { HEADING } from '../../../components/heading/constants/constants';
import Heading from '../../../components/heading/Heading';
import { VEC_ICON_NAME } from '../../../components/icons/constants';
import styles from './GetCompanySize.styles';
import commonStyles from '../OnboardingStepsCommonStyles';
import Onboarding from '../../../../libs/utility/Onboarding';
import { ONBOARDING_LOADING_STATES, ONBOARDING_ROUTES, ONBOARDING_STATES_MESSAGE_MAP } from '../constants';
import { useDispatch, useSelector } from 'react-redux';
import { componentKey as onboardingComponentKey, setNavigateNextFromCompanySize, setOnboardingData} from '../OnboardingSlice';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { saveOnboardingData } from '../OnboardingSaga';
import Loadable from '../../../components/loadable/Loadable';
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook';

export default function GetCompanySize() {
    
    const dispatch = useDispatch();
    const { loadingState, onboardingData, onboardingFormOptionsData, navigateNextFromCompanySize } = useSelector((state) => state[onboardingComponentKey]);
    const [selectedCompanyType, setSelectedCompanyType] = useState({});
    const navigate = useTxNavigate();
    const companyTypes = onboardingFormOptionsData?.BusinessType ?? [];
    
    useEffect(() => {
        if(!selectedCompanyType.id){
            const selectedOption = companyTypes.find((item) =>  item.id == onboardingData.BusinessType);
            setSelectedCompanyType({...selectedOption});
        }
        dispatch(setOnboardingData({BusinessType: (selectedCompanyType.id != null) ? selectedCompanyType.id : ""}))
    }, [selectedCompanyType.id]);

    useEffect(() => {
        if(navigateNextFromCompanySize){
            navigate(`/${ONBOARDING_ROUTES.ONBOARDING}/${ONBOARDING_ROUTES.FORM_QUANTITY}`);
            dispatch(setNavigateNextFromCompanySize(false));
        }
    }, [navigateNextFromCompanySize]);
    
    const handleNextButtonClick = () => {
        if(!onboardingData.BusinessType){
            dispatch(addNotifications({ heading: "Business type required", message: "To continue, please select your business type" }))
        }else{
            dispatch(saveOnboardingData({onboardingDataToSave: onboardingData, goToNextScreenCb: setNavigateNextFromCompanySize, nextScreenStateValue: true}));
        }
    };

    return (
        <>
            <Loadable
                currentState={loadingState.state}
                loadingStates={[ONBOARDING_LOADING_STATES.SAVE_ONBOARDING_ACTION_LOADING]}
                messageMap={ONBOARDING_STATES_MESSAGE_MAP}
                isNewLoadable={true}
            >
                <div style={commonStyles.onboardingStepContainer}>
                    <div style={{...commonStyles.formDiv, ...styles.formDivFullWidth}}>
                        <div style={styles.stepTitleContainer}>
                            <Heading type={HEADING.H1}>I’m with a</Heading>
                            <div>
                                <p style={styles.stepTitleDesc}>
                                    
                                </p>
                            </div>
                        </div>
                        <div style={styles.cardsGroupContainer}>
                            {
                                companyTypes.map((type, idx) => {
                                    return (
                                        <div style={styles.cardContainer} onClick={() => Onboarding.handleSelectOptionClick(idx, type, setSelectedCompanyType)}>
                                            <CardWIconTitleAndButton
                                                title={type.Label}
                                                icon={VEC_ICON_NAME.UPLOAD_FROM_COMPUTER}
                                                isHighlighted={selectedCompanyType?.id === type.id ? true : false}
                                                customStyles={styles.individualCardStyle}
                                            />
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <FooterWImageAndActionButtons
                        backButton={{
                            text: "Back",
                            clickCb: () => {navigate(`/${ONBOARDING_ROUTES.ONBOARDING}/${ONBOARDING_ROUTES.COMPANY}`)},
                        }}
                        nextButton={{
                            text: "Next",
                            clickCb: handleNextButtonClick,
                        }}
                    >
                        <span>The deadline to mail 1099s to taxpayers is usually Jan. 31.</span>
                    </FooterWImageAndActionButtons>
                </div>
            </Loadable>
        </>
    )
}